import { createAction, props } from '@ngrx/store';

export const showLoading = createAction('show Loading', props<{ loadingText: string }>());
export const hideLoading = createAction('hide Loading');